import { request } from './request';
import { getRequestConfig } from './config';
import { 
  UPDATE_PREFERENCES_ACTION,
  GET_PREFERENCES_ACTION,
  GET_LICENSES_ACTION,
  UPDATE_LICENSE_STATUS_ACTION,
  USER_REGISTRATION_ACTION,
  FORGOT_PASSWORD_ACTION,
  RESET_PASSWORD_ACTION,
  IS_USER_EXIST_ACTION,
  IS_EMAIL_EXIST_ACTION,
  IS_NPI_EXIST_ACTION,
  VERIFICATION_ACTION,
  REQUEST_NEW_TOKEN_ACTION,
  UPDATE_PROFILE_ACTION,
  GET_CONTACTS_ACTION,
  CREATE_CONTACT_ACTION,
  UPDATE_CONTACT_ACTION,
  DELETE_CONTACT_ACTION,
  RENAME_CONTACT_ACTION,
  CREATE_DEVICE,
  GET_NOTES,
  UPDATE_NOTES,
  DELETE_NOTES,
  UPDATE_PASSWORD_ACTION
} from './ajaxActions';
import { 
  REGISTRATION_SUCCESS_MESSAGE,
  OK,
  ERROR,
  TIMEOUT
} from './ajaxActionResponse';

import store from '@/store';

export const updatePreferences = (preferencesForm) => {
  const config = getRequestConfig(preferencesForm, UPDATE_PREFERENCES_ACTION, '/preferences/update');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const getPreferences = () => {
  const config = getRequestConfig({}, GET_PREFERENCES_ACTION, '/preferences/index');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const updateLicenseStatus = (licenseForm) => {
  const config = getRequestConfig(licenseForm, UPDATE_LICENSE_STATUS_ACTION, '/license/update-status');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const getLicenses = (licenseForm) => {
  const config = getRequestConfig(licenseForm, GET_LICENSES_ACTION, '/license/query');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const getContacts = () => {
  const config = getRequestConfig({}, GET_CONTACTS_ACTION, '/contacts/index');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
        resolve(response.data.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const createContact = (contactForm) => {
  const config = getRequestConfig(contactForm, CREATE_CONTACT_ACTION, '/contacts/add');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const updateContact = (contactForm) => {
  const config = getRequestConfig(contactForm, UPDATE_CONTACT_ACTION, '/contacts/update');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        // Vue.actions.inlineUpdateApplicationModel()
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const deleteContact = (contactForm) => {
  const config = getRequestConfig(contactForm, DELETE_CONTACT_ACTION, '/contacts/delete');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const renameContact = (contactForm) => {
  const config = getRequestConfig(contactForm, RENAME_CONTACT_ACTION, '/contacts/rename');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const createDevice = (deviceForm) => {
  const config = getRequestConfig(deviceForm, CREATE_DEVICE, '/meter/create')
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  })
}

export const setPrimaryContact = (contactForm) => {
  const config = getRequestConfig(contactForm, RENAME_CONTACT_ACTION, '/contacts/set-primary-contact');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const updateProfile = (profileForm) => {
  const config = getRequestConfig(profileForm, UPDATE_PROFILE_ACTION, '/session/updateProfile');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        if(response.data.data.patient)
         {
           store.dispatch('login/inlineUpdateApplicationModel',response.data.data);
         }
        resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const acquireByExternalId = (form) => {
  const config = getRequestConfig(form, null , '/session/acquireByExternalId');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const summaryByExternalId = (form) => {
  const config = getRequestConfig(form, null , '/session/summaryByExternalId');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const finalizeRegistration = (externid) => {
  // const config = getRequestConfig(registrationForm, USER_REGISTRATION_ACTION);
  const config = getRequestConfig({externid}, null, '/sessionless/finalizeRegistration');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data.username);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}



export const register = (registrationForm) => {
  // const config = getRequestConfig(registrationForm, USER_REGISTRATION_ACTION);
  const config = getRequestConfig(registrationForm, USER_REGISTRATION_ACTION, '/sessionless/register');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
//        resolve(response.data.data.username);
// data can now contain username and externid
          resolve(response.data.data);
      } else {
        reject(response.data.error);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const isUserExist = (username) => {
  // const config = getRequestConfig(username, IS_USER_EXIST_ACTION);
  const config = getRequestConfig(username, IS_USER_EXIST_ACTION, '/sessionless/isUserExist');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data.data.isUserExist);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const isEmailExist = (email) => {
  // const config = getRequestConfig(username, IS_USER_EXIST_ACTION);
  const config = getRequestConfig(email, IS_EMAIL_EXIST_ACTION, '/sessionless/isEmailExist');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data.data.isEmailExist);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const isNpiExist = (npi) => {
  // const config = getRequestConfig(username, IS_USER_EXIST_ACTION);
  const config = getRequestConfig(npi, IS_NPI_EXIST_ACTION, '/sessionless/isNpiExist');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data.data.isNpiExist);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

/**
 * @param {Object} verificationForm {username, token}
 */
export const verify = (verificationForm) => {
  // const config = getRequestConfig(verificationForm, VERIFICATION_ACTION);
  const config = getRequestConfig(verificationForm, VERIFICATION_ACTION, '/sessionless/verify');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

/**
 * @param {Object} verificationForm {username}
 */
export const requestNewToken = (username) => {
  // const config = getRequestConfig(username, REQUEST_NEW_TOKEN_ACTION);
  const config = getRequestConfig(username, REQUEST_NEW_TOKEN_ACTION, '/sessionless/requestNewToken');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK)
        resolve(response.data);
      else 
        reject(response.data.message);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const forgotPassword = (email) => {
  // const config = getRequestConfig(email, FORGOT_PASSWORD_ACTION);
  const config = getRequestConfig(email, FORGOT_PASSWORD_ACTION, '/sessionless/forgotPassword');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK)
        resolve(response.data);
      else 
        reject(response.data.message);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const updatePassword = (form) => {
  const config = getRequestConfig(form, UPDATE_PASSWORD_ACTION, '/sessionless/updatePassword')
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK)
        resolve(response.data)
      else
        reject(response.data)
    })
    .catch((err) => {
      reject(err)
    })
  })
}

export const resetPassword = (form) => {
  // const config = getRequestConfig(form, RESET_PASSWORD_ACTION);
  const config = getRequestConfig(form, RESET_PASSWORD_ACTION, '/sessionless/resetPassword');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data);
      if (response.data.status === OK)
        resolve(response.data);
      else 
        reject(response.data.message);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
// export const createContact = (contactForm) => {
//   const config = getRequestConfig(contactForm, CREATE_CONTACT_ACTION, '/contacts/add');
//   return new Promise((resolve, reject) => {
//     request(config)
//     .then((response) => {
//       if (response.data.status === OK) {
//         resolve(response.data.data);
//       } else {
//         reject(response.data.error);
//       }
//     })
//     .catch((err) => {
//       reject(err);
//     });
//   });
// };

export const updateNotes = (form) => {
  const config = getRequestConfig(form, UPDATE_NOTES, '/notes/update')
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data)
      }
      else {
        reject(response.data.error)
      }
    })
    .catch((err) => {
      reject(err)
    })
  })
}

export const deleteNotes = (form) => {
  const config = getRequestConfig(form, DELETE_NOTES, '/notes/delete')
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data)
      }
      else {
        reject(response.data.error)
      }
    })
    .catch((err) => {
      reject(err)
    })
  })
}

export const getNotes = (form) => {
  const config = getRequestConfig(form, GET_NOTES, '/notes/index')
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data)
      }
      else {
        reject(response.data.error)
      }
    })
    .catch((err) => {
      reject(err)
    })
  })
}